<template>
  <div class="calc-bottom">
    <IconBank />
    <span>{{ count }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import IconBank from '../shared/IconBank.vue';

export default defineComponent({
  components: {
    IconBank
  },

  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
})

</script>

<style lang="scss" scoped>
.calc-bottom {
  height: 64px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 6px;
  color: #777;

  span {
    color: var(--main-color);
  }
}
</style>
